import { Box, Grid2, Typography } from "@mui/material";
import { NavLink, useNavigate } from "react-router-dom";
import {
  convertToPixelFromVW,
  convertToPixels,
} from "../../utils/ViewportUtils";
import { useContext, useMemo } from "react";

import { APP_ROUTES } from "../../constants/AppRoutes";
import BackgroundGraphicsTop from "../../assets/background-top.svg";
import NavButton from "../styled/NavButton";
import { ViewportContext } from "../../contexts/viewportContext";
import WWTLogo from "../../assets/wwt-logo.svg";
import logo from "../../assets/aips-logo.svg";

function Header() {
  const navigate = useNavigate();

  const vpContext = useContext(ViewportContext);
  const useInVH = vpContext?.is4k || vpContext?.is2k;

  const getClipPath = useMemo(() => {
    return `path('M 0 0 H ${convertToPixels("42.5vw")} V ${
      useInVH ? convertToPixels("6vh") : 65
    } H ${convertToPixelFromVW(2.5)} Z')`;
  }, [useInVH]);

  return (
    <>
      <Grid2
        container
        sx={{
          paddingLeft: 1,
          marginLeft: "auto",
          width: "100%",
          height: "100%",
        }}
      >
        <NavButton
          onClick={() => navigate("/", { replace: false })}
          // startIcon={<img src={logo} width={vpContext?.is4k ? '80vw' : '100%'} alt='logo'></img>}>
          startIcon={
            <img
              src={logo}
              style={{ aspectRatio: "1/1", width: "2vw" }}
              alt="logo"
            ></img>
          }
        >
          <Typography
            variant="h5"
            sx={{
              color: "#242A32",
              fontWeight: 500,
            }}
          >
            AIPS <span style={{ color: "#00A9B1" }}>iHub</span>
          </Typography>
        </NavButton>
        <Box
          sx={{
            "--width": "42.5vw",
            "--height": "100%",
            marginLeft: "auto",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            height: "var(--height)",
            width: "var(--width)",
            position: "relative",
            // background: '#242E35',
            boxSizing: "border-box",
            "&::before": {
              content: '" "',
              position: "absolute",
              top: 0,
              transform: "translate(-87.5%)",
              width: { lg: "50%" },
              height: "var(--height)",
              background: `url('${BackgroundGraphicsTop}') no-repeat center right`,
              "@media (min-width: 2561px)": {
                backgroundSize: "contain",
              },
            },
            "&&::after": {
              content: '" "',
              position: "absolute",
              top: 0,
              zIndex: -1,
              width: "inherit",
              height: "inherit",
              background: "#242E35",
              clipPath: getClipPath,
            },
          }}
        >
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-evenly",
              flex: 1,
            }}
          >
            <NavLink
              to={APP_ROUTES.ASK_GUARDIAN}
              className={({ isActive, isPending }) =>
                isPending ? "pending" : isActive ? "active" : ""
              }
              style={{ fontSize: "1.125rem" }}
            >
              ASK iHUB
            </NavLink>
            <NavLink
              to={APP_ROUTES.DEVIATION_RADAR}
              className={({ isActive, isPending }) =>
                isPending ? "pending" : isActive ? "active" : ""
              }
              style={{ fontSize: "1.125rem" }}
            >
              DEVIATION RADAR
            </NavLink>
            <NavLink
              to={APP_ROUTES.KPI_REPORTING}
              className={({ isActive, isPending }) =>
                isPending ? "pending" : isActive ? "active" : ""
              }
              style={{ fontSize: "1.125rem" }}
            >
              KPI REPORTS
            </NavLink>
          </Box>
        </Box>
        <Grid2
          size={{ xs: 0.5 }}
          sx={{
            height: "100%",
            // aspectRatio: 1 / 1,
            // marginRight: 1,
            background: "var(--text-light)",
            display: "grid",
            placeContent: "center",
            boxSizing: "border-box",
          }}
        >
          <img
            style={{
              display: "block",
              width: "3vw",
            }}
            src={WWTLogo}
            alt="."
          />
        </Grid2>
      </Grid2>
    </>
  );
}

export default Header;
